import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const SkillsSection = ({ user }) => {
  const [showAll, setShowAll] = useState(false);
  const skills = user?.skills || [];
  const initialDisplayCount = 5;

  // Show only first N skills initially
  const displayedSkills = showAll ? skills : skills.slice(0, initialDisplayCount);
  const hasMoreSkills = skills.length > initialDisplayCount;

  if (!skills.length) {
    return (
      <div className="bg-white rounded-lg shadow-lg p-6 w-full mx-auto mt-4">
        <h2 className="text-xl font-bold text-gray-900 mb-4">Skills</h2>
        <p className="text-gray-500 italic">No skills listed yet</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-lg p-6 w-full mx-auto mt-4">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold text-gray-900">Skills</h2>
        <span className="text-sm text-gray-500">{skills.length} skills</span>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2">
        {displayedSkills.map((skill) => (
          <div
            key={skill.id}
            className="flex items-center py-2 px-3 bg-gray-50 hover:bg-gray-100 rounded-lg transition-colors duration-200"
          >
            <div className="w-2 h-2 rounded-full bg-green-500 mr-2"></div>
            <span className="text-gray-700 font-medium text-sm">{skill.name}</span>
          </div>
        ))}
      </div>

      {hasMoreSkills && (
        <button
          onClick={() => setShowAll(!showAll)}
          className="mt-4 flex items-center gap-1 text-blue-600 hover:text-blue-800 font-medium transition-colors duration-200 group"
        >
          {showAll ? (
            <>
              Show less
              <ChevronUp className="w-4 h-4 transition-transform group-hover:-translate-y-0.5" />
            </>
          ) : (
            <>
              Show all {skills.length} skills
              <ChevronDown className="w-4 h-4 transition-transform group-hover:translate-y-0.5" />
            </>
          )}
        </button>
      )}
    </div>
  );
};

export default SkillsSection;